import { render } from "./QueriedKnowledgeList.vue?vue&type=template&id=10adefe2&scoped=true"
import script from "./QueriedKnowledgeList.vue?vue&type=script&lang=js"
export * from "./QueriedKnowledgeList.vue?vue&type=script&lang=js"

import "./QueriedKnowledgeList.vue?vue&type=style&index=0&id=10adefe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10adefe2"]])

export default __exports__